import src from "IMAGE";
export default { src, width: 46, height: 86, blurWidth: 0, blurHeight: 0};
